import { SxProps, Theme } from '@mui/material'

export const listItemButtonStyle: SxProps<Theme> = () => ({
	padding: '0',
	marginBottom: '12px',
})

export const avatarContainerStyle: SxProps<Theme> = () => ({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	py: '4px',
})

export const avatarStyle: SxProps<Theme> = (theme: Theme) => ({
	bgcolor: theme.palette.brand.main,
	borderRadius: '8px',
	width: '40px',
	height: '40px',
})

export const displayedDetailStyle = (theme: Theme) => ({
	'.MuiListItemText-primary': {
		color: theme.palette.text.primary,
		fontSize: '14px',
	},
	'.MuiListItemText-secondary': {
		fontSize: '10px',
	},
})
